import { render, staticRenderFns } from "./BasicTable.vue?vue&type=template&id=67c95474&"
import script from "./BasicTable.vue?vue&type=script&lang=js&"
export * from "./BasicTable.vue?vue&type=script&lang=js&"
import style0 from "./BasicTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports